import * as XLSX from 'xlsx';

function normalizarEncabezado(texto) {
  return String(texto)
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // quita acentos
    .trim()
    .toUpperCase();
}

function buscarValor(fila, ...nombresPosibles) {
  const buscados = nombresPosibles.map(normalizarEncabezado);
  for (const clave of Object.keys(fila)) {
    if (buscados.includes(normalizarEncabezado(clave))) {
      return fila[clave];
    }
  }
  return undefined;
}

export async function parseArchivoPermissions(file) {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: 'array' });
  const primeraHoja = workbook.Sheets[workbook.SheetNames[0]];
  const filasCrudas = XLSX.utils.sheet_to_json(primeraHoja, { defval: '' });

  const filas = filasCrudas.map((filaCruda, indice) => ({
    fila: indice + 2, // +2: encabezado + índice base 1, para mensajes de error legibles
    ID: buscarValor(filaCruda, 'ID'),
    PERMISSION: buscarValor(filaCruda, 'PERMISSION'),
    MAIL: buscarValor(filaCruda, 'MAIL'),
  }));

  const errores = [];
  filas.forEach((f) => {
    if (!f.ID) errores.push(`Fila ${f.fila}: falta ID`);
    if (!f.MAIL) errores.push(`Fila ${f.fila}: falta MAIL`);
    if (!f.PERMISSION) errores.push(`Fila ${f.fila}: falta PERMISSION`);
  });

  return { filas, errores };
}
